import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
    selector: 'op-schedule-period',
    templateUrl: './schedule-period.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SchedulePeriodComponent {}